import { render, staticRenderFns } from "./Profitability.vue?vue&type=template&id=ca8be228&scoped=true"
import script from "./Profitability.vue?vue&type=script&lang=js"
export * from "./Profitability.vue?vue&type=script&lang=js"
import style0 from "./Profitability.vue?vue&type=style&index=0&id=ca8be228&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8be228",
  null
  
)

export default component.exports